import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from 'material-ui/LinearProgress';

const linearProgressStyle = { height: '6px', backgroundColor: '#bdbdbd' };

class AutoAllocateIndicator extends React.Component {
  componentWillUnmount() {
    this.props.refreshScheduler();
  }

  render() {
    return (
      <LinearProgress
        mode={this.props.indeterminate ? 'indeterminate' : 'determinate'}
        value={parseInt(this.props.progress, 10)}
        style={linearProgressStyle}
      />
    );
  }
}

AutoAllocateIndicator.defaultProps = {
  indeterminate: false,
  progress: 0,
};

AutoAllocateIndicator.propTypes = {
  refreshScheduler: PropTypes.func.isRequired,
  progress: PropTypes.number,
  indeterminate: PropTypes.bool,
};

export default AutoAllocateIndicator;
